export function getClassFromConfidValue(confidence: number, colorBlind: boolean = false) {
  if (colorBlind) {
    if (confidence == -1) return "unknown-confid-cb";
    if (confidence > 95) return "good-confid-cb";
    if (confidence > 90) return "med-high-confid-cb";
    if (confidence > 85) return "med-confid-cb";
    if (confidence > 80) return "med-low-confid-cb";
    return "bad-confid-cb";
  }
  // Default color scheme
  if (confidence == -1) return "unknown-confid";
  if (confidence > 95) return "good-confid";
  if (confidence > 90) return "med-high-confid";
  if (confidence > 85) return "med-confid";
  if (confidence > 80) return "med-low-confid";
  return "bad-confid";
}
